import './app/style.scss';
import './app/theme.scss';

import './node_modules/@synisys/idm-ng-controls/lib/kendo/styles/kendo.common-material.min.css';
import './node_modules/@synisys/idm-ng-controls/lib/kendo/styles/kendo.material.min.css';
import './node_modules/@synisys/idm-ng-controls/lib/kendo/styles/kendo.rtl.min.css';

